import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import CyberComponent from "containers/CyberComponent";
import { Form } from "react-bootstrap";
import RequestControls from "containers/request/RequestControls";
import Instructions from "containers/request/OTA/OTADeviceInfoBubble";
import RequestManufacturer from "components/request/RequestManufacturer";
import RequestDescChanges from "components/request/RequestDescChanges";
import BatteryParentDetails from "components/request/BatteryParentDetails";
import RequestEcoModel from "containers/request/ACR/RequestEcoModelACR";
import RequestRevision from "components/request/RequestRevision";
import NonSarSites from "containers/request/battery/NonSarSites/NonSarSites";
import NonSarSitesReadonly from "containers/request/battery/NonSarSites/NonSarSitesReadonly";
import SubmissionDetails from "containers/request/RequestContent/SubmissionDetails";
import RequestParentLink from "components/request/RequestParentLink";
import { setValue, setBatteryRequestPermissions } from "actions/request";
import { initEcoACR, updateECODeviceInfoACR } from "actions/battery/acrRequest";
import { mapNonSarManufSites } from "actions/battery/batteryRequests";
import { submitWizardStep } from "actions/wizard";
import { hasStringValue } from "helpers/RequestHelper";
import { getRequestOwner } from "helpers/UsersHelper";

class RequestECOContainerACR extends CyberComponent {
  modelField = this.props.request.id ? "modelName" : "existedModel";

  componentDidMount() {
    const { request, user, initEcoACR } = this.props;
    const ownerId = getRequestOwner(request, user);

    // fetch only for the first time on submissions
    if (!this.validate() && !request.id) {
      initEcoACR(request.ieee, ownerId);
    }

    // fetch for existed requests
    if (request.id) {
      initEcoACR(request.ieee, ownerId).then(() =>
        this.props.mapNonSarManufSites(request.linkedManufsites)
      );
    }

    // set permissions for existed request
    this.props.setBatteryRequestPermissions(request, user);
  }

  onSaveClick = () => {
    const { request, sites, updateECODeviceInfoACR } = this.props;
    updateECODeviceInfoACR(request, sites.nonSarSites);
  };

  validateRevision() {
    return hasStringValue(this.props.request, "revision");
  }

  validateDesc() {
    return hasStringValue(this.props.request, "descriptionOfChange");
  }

  validateManufSites() {
    const { sites } = this.props;
    return sites && sites.nonSarSites && _.some(sites.nonSarSites, "checked");
  }

  validate() {
    const { user } = this.props;

    // don't need to validate if form is non-editable
    if (user.canEditDeviceInfo === false) return true;

    // check if all required fields are valid
    return (
      this.validateRevision() &&
      this.validateManufSites() &&
      this.validateDesc()
    );
  }

  render() {
    const { request, user } = this.props;
    const { canEditDeviceInfo } = user;
    const saveHandler = canEditDeviceInfo ? this.onSaveClick : null;

    return (
      <div>
        <Instructions />
        <Form horizontal>
          <RequestParentLink certPrefix="acr" />
          <BatteryParentDetails />
          <hr />
          <RequestManufacturer />
          <RequestEcoModel />
          <hr />
          {request[this.modelField] && (
            <>
              <RequestRevision
                fieldId="revision"
                editable={canEditDeviceInfo}
              />
              <RequestDescChanges />
              <SubmissionDetails />
              <hr />
              {canEditDeviceInfo ? <NonSarSites /> : <NonSarSitesReadonly />}
            </>
          )}
          <RequestControls isValid={this.validate()} onSave={saveHandler} />
        </Form>
      </div>
    );
  }
}

function mapStateToProps({ app, request, user, sites }) {
  return { app, request, user, sites };
}

export default connect(mapStateToProps, {
  initEcoACR,
  submitWizardStep,
  updateECODeviceInfoACR,
  setValue,
  setBatteryRequestPermissions,
  mapNonSarManufSites
})(RequestECOContainerACR);
